import Joi, { number } from '@hapi/joi'

export const packageCreationSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Operatin Entity cannot have invalid characters`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Collectionpoint cannot have invalid characters`,
        "any.required": `Collectionpoint required`
    }),
    aspNetUserId: Joi.number().label("User").messages({
        "any.invalid": `User cannot have invalid characters`,
        "any.required": `User required`
    }),
    // aspNetUserId: Joi.when('edit', { is: true, then: '0' || Joi.number(), otherwise: Joi.number().invalid(0).required().label("User").messages({
    //     "any.invalid": `User cannot have invalid characters`,
    //     "any.required": `User required`,
    // }) }),

    operationalCardID: Joi.number().invalid(0).required().label("Operation Card").messages({
        "any.invalid": `Operation Card cannot have invalid characters`,
        "any.required": `Operation Card required`
    }),
    packageCode: Joi.string().required().min(2).max(2).label("Package Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Package Code required`,
        "string.pattern.base": `Package Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
    packageName: Joi.string().required().label("Package Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Package Name required`,
        "string.pattern.base": `Please enter valid package name`,
    }),
    backupLoginPassword: Joi.when('edit', {
        is: true, then: '', otherwise: Joi.string().required().label("Backup login Password").regex(/^(?=.{5,})/).messages({
            "string.pattern.base": `"Invalid Password"`,
            "string.empty": `Backup Login Password Required`,
        })
    }),
    confirmPassword: Joi.when('edit', {
        is: true, then: '', otherwise: Joi.string().required().label("Confirm Password").regex(/^(?=.{5,})/).messages({
            "string.pattern.base": `"Invalid Password"`,
            "string.empty": `Confirm Password Required`,
        })
    }),
    vehicleID: Joi.string().label("Vehicle"),
    isActive: Joi.boolean().label("Active"),
    removeUser: Joi.boolean().label("Remove User"),
    edit: Joi.boolean()
}

export const packageCreationFilteringSchema = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please Select the Group `,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please Select the operationEntity`,
        "any.required": `operationEntityID required`
    }),
    collectionPointID: Joi.number().invalid().required().label("Collectionpoint").messages({
        "any.invalid": `Please Select the collectionPointID`,
        "any.required": `operationEntityID required`
    }),

}

export const packagePasswordResetSchemaObject = {
    newPassword: Joi.string().required().label("Password").regex(/^(?=.{5,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `New Password Required`,
    }),
    confirmPassword: Joi.string().required().label("Password").regex(/^(?=.{5,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `Confirm Password Required`,
    }),
}